import React, { useState } from 'react'
import useMultipleCostInvoiceSave from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceSave'
import { GButton } from 'tennders-common/form/components'
import useMultipleCostInvoiceDrafts from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceDrafts'
import useTranslation from 'next-translate/useTranslation'
import { FINANCE_MODULE_INVOICE_OVERRIDE_RULES } from 'tennders-stracture/libs/permissions'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'

const MultipleCostInvoiceSaveButton = (props) => {
  const {
    lines,
    discountLines,
    extraCostsLines,
    form,
    documents,
    changes,
    totalExtraCostsIncVat,
    setFormErrors,
    setLineErrors,
    setLineForm,
    onClose,
    deletable,
    calculations,
    paymentTermProblem,
    transactionProblem,
    selectedTransaction
  } = props
  const { saveDraft, loading: draftLoading } = useMultipleCostInvoiceDrafts({ onClose, setFormErrors })
  const [confirmDelete, setConfirmDelete] = useState(false)

  const { loading, deleteInvoice, deleting, handleSubmit } = useMultipleCostInvoiceSave({
    lines,
    calculations,
    discountLines,
    extraCostsLines,
    form,
    invoiceDocuments: documents,
    totalExtraCostsIncVat,
    setFormErrors,
    setLineErrors,
    setLineForm,
    onClose,
    selectedTransaction
  })

  const { t } = useTranslation()
  const {
    loading: deletingDraft,
    deleteDraft
  } = useMultipleCostInvoiceDrafts({ onClose })

  const deleteAction = async () => {
    if (confirmDelete) {
      return deleteInvoice(form.id)
    }
    setConfirmDelete(true)
  }
  const creditNoteProblem = form.creditNote && !form.creditNoteFor

  return (
    <>
      {paymentTermProblem && (
        <div className="mb-10 d-flex row justify-end w-100">
          <span className="color-red">
            {t('costInvoice:payment_term_do_not')}
          </span>
        </div>
      )}
      {creditNoteProblem && (
        <div className="mb-10 d-flex row justify-end w-100">
          <span className="color-red">
            {t('costInvoice:you_have_select_invoice')}
          </span>
        </div>
      )}
      {transactionProblem && (
        <div className="mb-10 d-flex row justify-end w-100">
          <span className="color-red">
            {t('costInvoice:you_have_to_have_transaction')}
          </span>
        </div>
      )}
      {form?.status === 'sent-to-delete' && (
        <div className="mb-10 d-flex row justify-end w-100">
          <span className="color-red">
            {t('costInvoice:invoice_sent_to_delete')}
          </span>
        </div>
      )}
      {changes && Object.keys(changes).length > 0 && (
        <>
          <p className="color-red mb-10 d-flex row justify-end w-100">
            <b>{t('costInvoice:changes_to_be_approved')}</b>
          </p>
          {Object.keys(changes).map((key) => (
            Array.isArray(changes[key])
              ? (
                <div key={key} className="mb-10 d-flex row justify-end w-100">
                  <>
                    <span className="color-red">
                      {t('costInvoice:' + key) + ' '}
                    </span> &nbsp; changed from  &nbsp;<b>{changes[key][1]}</b> &nbsp; to &nbsp;  <b>{ changes[key][0]}</b>
                  </>
                </div>
              )
              : (
                <div key={key} className="mb-10 d-flex row justify-end w-100">
                  <span className="color-red">
                    {t('costInvoice:' + key) + ' changed'}
                  </span>
                </div>
              )
          ))}
        </>
      )}
      <div className="d-flex row justify-end w-100">
        {(!form.id || form.draftId) && (
          <GButton
            submitting={draftLoading}
            onClick={() => saveDraft({
              ...form,
              lines,
              discountLines,
              extraCostsLines,
              documents
            })}
            className="text-uppercase btn-border color-p mr-8"
          >
            {t('costInvoice:save_draft')}
          </GButton>
        )}
        {(form.draftId) && (
          <GButton
            submitting={deletingDraft}
            onClick={() => deleteDraft(form.draftId)}
            className="text-uppercase btn-border color-p mr-8"
          >
            {t('costInvoice:delete_draft')}
          </GButton>
        )}
        {(form.status !== 'sent-to-delete' && deletable && !form.draftId) && (
          <>
            <GButton
              submitting={deleting}
              onClick={() => deleteAction()}
              className="text-uppercase btn color-p bold pl-60 pr-60 mr-8"
            >
              {confirmDelete ? t('costInvoice:confirm_delete') : t('costInvoice:delete')}
            </GButton>
            {confirmDelete && (
              <GButton
                onClick={() => setConfirmDelete(false)}
                className="text-uppercase btn-border color-p mr-8"
              >
                {t('common:cancel')}
              </GButton>
            )}
          </>
        )}
        <RequiresPermission requiredPermissions={[FINANCE_MODULE_INVOICE_OVERRIDE_RULES]}>
          {(form.status !== 'sent-to-delete' && !deletable && !form.draftId) && (
            <>
              <GButton
                submitting={deleting}
                onClick={() => deleteAction()}
                className="text-uppercase btn color-p bold pl-60 pr-60 mr-8"
              >
                {confirmDelete ? t('costInvoice:confirm_delete') : t('costInvoice:delete')}
              </GButton>
              {confirmDelete && (
                <GButton
                  onClick={() => setConfirmDelete(false)}
                  className="text-uppercase btn-border color-p mr-8"
                >
                  {t('common:cancel')}
                </GButton>
              )}
            </>
          )}
        </RequiresPermission>
        {form.status !== 'sent-to-delete' && (
          <GButton
            disabled={paymentTermProblem || transactionProblem || creditNoteProblem || (changes && Object.keys(changes).length) > 0}
            submitting={loading}
            onClick={handleSubmit}
            className="text-uppercase btn color-p bold pl-60 pr-60"
          >
            {t('common:save')}
          </GButton>
        )}
      </div>
    </>
  )
}

export default React.memo(MultipleCostInvoiceSaveButton)
